import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined

const EditSalesSetup = () => {
    const { id } = useParams(); // Get the sales setup ID from the URL
    const navigate = useNavigate();

    // State for holding the sales setup data
    const [salesSetup, setSalesSetup] = useState({
        customerLabel: '',
        logisticDetails: false,
        creditControl: false,
        documentClassification: false,
        salesmanWiseBilling: '',
        agentWiseBilling: false,
    });

    // Fetch sales setup details on component mount
    useEffect(() => {
        fetch(`${BASE_URL}salessetup/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    setSalesSetup(data.data);
                }
            })
            .catch((error) => console.error('Error fetching sales setup details:', error));
    }, [id]);

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        fetch(`${BASE_URL}salessetup/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(salesSetup),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                if (data.status === 'success') {
                    alert('Sales setup updated successfully!');
                    navigate('/EditSalesSetup/1'); // Assuming the route to list is `/SalesSetupList`
                } else {
                    alert('Error updating sales setup. Please try again.');
                }
            })
            .catch((error) => {
                console.error('Error updating sales setup:', error);
                alert('Error updating sales setup. Please check the console for more details.');
            });
    };

    // Handle input change for all fields
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setSalesSetup({ ...salesSetup, [name]: checked });
        } else {
            setSalesSetup({ ...salesSetup, [name]: value });
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Sales Setup</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Sales Setup Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header"></div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {/* Form Fields */}
                                    <div className="mb-3">
                                        <label htmlFor="customerLabel" className="form-label">Customer Label</label>
                                        <input
                                            type="text"
                                            id="customerLabel"
                                            name="customerLabel"
                                            className="form-control"
                                            value={salesSetup.customerLabel}
                                            onChange={handleChange}
                                            placeholder="Enter customer label"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="logisticDetails" className="form-label">Logistic Details</label>
                                        <input
                                            type="checkbox"
                                            id="logisticDetails"
                                            name="logisticDetails"
                                            className="form-check-input"
                                            checked={salesSetup.logisticDetails}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="creditControl" className="form-label">Credit Control</label>
                                        <input
                                            type="checkbox"
                                            id="creditControl"
                                            name="creditControl"
                                            className="form-check-input"
                                            checked={salesSetup.creditControl}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="documentClassification" className="form-label">Document Classification</label>
                                        <input
                                            type="checkbox"
                                            id="documentClassification"
                                            name="documentClassification"
                                            className="form-check-input"
                                            checked={salesSetup.documentClassification}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="salesmanWiseBilling" className="form-label">Salesman Wise Billing</label>
                                        <input
                                            type="text"
                                            id="salesmanWiseBilling"
                                            name="salesmanWiseBilling"
                                            className="form-control"
                                            value={salesSetup.salesmanWiseBilling}
                                            onChange={handleChange}
                                            placeholder="Enter salesman wise billing"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="agentWiseBilling" className="form-label">Agent Wise Billing</label>
                                        <input
                                            type="checkbox"
                                            id="agentWiseBilling"
                                            name="agentWiseBilling"
                                            className="form-check-input"
                                            checked={salesSetup.agentWiseBilling}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">
                                            Update Sales Setup
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditSalesSetup;
